module.exports = __webpack_public_path__ + "static/img/sort1.3.ac8cd47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sort1.3.png
// module id = Jq4Y
// module chunks = 1